// https://docs.openx.jp/developers/bidder/bidder-lite-async-implementation.html

import Logger from '../appl/logger'
import GoogleAdService from './google-ad-service'

function toOxUnit(slot: SlotDefinition): OxUnit {
    const oxUnit: OxUnit = [slot.name, [slot.size], slot.id]
    if (slot.targeting) oxUnit.push(slot.targeting)
    return oxUnit
}

export default class OpenXBidderService implements BidderService {
    public static readonly NAME = 'OpenX'
    public readonly name = OpenXBidderService.NAME
    public readonly oxUnits: Dict<OxUnit> = {}

    public constructor(private readonly adService: GoogleAdService) {}

    /**
     * @override
     */
    public addSlot(...slots: SlotDefinition[]) {
        slots.filter(slot => slot.useOpenX).forEach(slot => this.addOxUnit(slot))
    }

    /**
     * @override
     */
    public requestBids(slots: SlotDefinition[], callback: Command) {
        const oxUnits = this.getOxUnits(slots)
        if (oxUnits.length < 1) {
            Logger.warn('OpenX 広告枠 がないため OpenX での入札は行いません', slots)
            callback()
            return
        }

        Logger.debug('OpenX 広告枠の入札を開始します', oxUnits)
        Logger.time('OpenX 広告入札リクエスト')

        window.oxDone = () => {
            Logger.timeEnd('OpenX 広告入札リクエスト')
            callback()
        }

        try {
            if (window.OX && window.OX.dfp_bidder) {
                Logger.debug('OX の準備ができているので addSlots を呼び出します')
                window.OX.dfp_bidder.addSlots(oxUnits, window.oxDone)
            } else {
                Logger.debug('OX の準備ができていないので OX_dfp_ads に広告枠を追加します')
                window.OX_dfp_ads.push(...oxUnits)
            }
        } catch (e) {
            Logger.error('OpenX の入札に失敗しました', e)
            callback()
        }
    }

    public preRenderAds(slots: SlotDefinition[]) {
        window.googletag.cmd.push(() => {
            const googleSlots = slots.map(slot => this.adService.getSlotById(slot.id))
            if (window.OX && window.OX.dfp_bidder) {
                window.OX.dfp_bidder.setOxTargeting(googleSlots)
            }
        })
    }

    private addOxUnit(slot: SlotDefinition) {
        this.oxUnits[slot.id] = toOxUnit(slot)
        Logger.debug(`OpenX 広告枠 [${slot.id}]`, this.oxUnits[slot.id])
    }

    private getOxUnits(slots: SlotDefinition[]) {
        return slots.filter(slot => slot.id in this.oxUnits).map(slot => this.oxUnits[slot.id])
    }
}
